import { Chip, ChipProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

const TAG_COLORS: Record<string, 'primary' | 'success' | 'warning' | 'secondary' | 'default'> = {
  credit: 'primary',
  revenue: 'success',
  worksheet: 'warning',
  payout: 'secondary',
}

const getTagColor = (tag: string): 'primary' | 'success' | 'warning' | 'secondary' | 'default' =>
  TAG_COLORS[tag.toLowerCase()] || 'default'

interface TagChipProps extends Omit<ChipProps, 'label' | 'color'> {
  tag: string
}

const TagChip = ({ tag, ...chipProps }: TagChipProps) => {
  const { t } = useTranslation()

  return (
    <Chip
      label={t(`enum.tags.${tag}` as const, { defaultValue: tag })}
      color={getTagColor(tag)}
      {...chipProps}
    />
  )
}

export default TagChip
